import { render, staticRenderFns } from "./SocialStatuseChangeActivationType.vue?vue&type=template&id=4ca848c4&"
import script from "./SocialStatuseChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports